<template>
    <div>
        <div class="participateBox">
            <div class="participate">参与主体</div>
            <div class="signed">签署方信息</div>
            <div class="operation">操作</div>
        </div>
        <div class="chooseBox">
            <div class="choose">
                <el-select v-model="valuetype" placeholder="请选择">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="information">
                <el-input  v-model="name"  onkeyup="value=value.replace(/[^\u4E00-\u9FA5]/g,'')" placeholder="真实姓名" style="width: 50%"></el-input>
                <el-input  v-model="phone" oninput ="value=value.replace(/[^0-9.]/g,'')" maxlength="11" placeholder="请输入手机号" style="margin: 0px 5px;width: 80%"></el-input>
                <el-input  v-model="enterprise" placeholder="请输入企业完整名称" onkeyup="value=value.replace(/[^\u4E00-\u9FA5]/g,'')" v-if="this.valuetype=='enterprise'"></el-input>
            </div>
            <div class="operate">
                <el-button  class="View">设置</el-button>
                <el-button  class="View">查看</el-button>
                <el-button  class="View">清空</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "unilateral",
        data() {
            return {
                name:'', //姓名
                phone:'', //手机号
                enterprise:'', //企业名称
                options: [{
                    value: 'personal',
                    label: '个人'
                }, {
                    value: 'enterprise',
                    label: '企业'
                }],
                valuetype: 'personal'
            }
        },

    }
</script>

<style scoped>
    .participateBox{
        display: flex;
        align-items: center;
        height: 50px;
        background-color: #f3f3f9;
        color: #525961;
        padding: 0px 20px;
    }
    .participate{
        width: 20%;
    }
    .signed{
        width: 40%;
    }
    .operation{
        width: 40%;
        text-align: center;
    }
    /deep/.el-select--small{
        width: 100px;
    }
    .chooseBox{
        display: flex;
        margin: 20px 0px;
        padding: 0px 20px;
    }
    .choose{
        width: 20%;
    }
    .information{
        width: 40%;
        display: flex;
    }
    .operate{
        width: 40%;
        text-align: center;
    }
    .operate>button{
        background-color: #3d62f6;
        color: #fff;
    }
</style>
